
export const TaskStatusSchemaDef = {
    timestamp: {
        type: ['string', 'null']
    },
    userId: {
        type: ['string', 'null']
    }
}

export const TaskStatusGroupSchemaObjectDef = {
    type: [ 'object', 'null' ],
    "properties": {
        scheduleRequested: {
            type: ['object', 'null'],
            "properties" : TaskStatusSchemaDef
        },
        scheduled: {
            type: ['object', 'null'],
            "properties" : TaskStatusSchemaDef
        },
        inProgress: {
            type: ['object', 'null'],
            "properties" : TaskStatusSchemaDef
        },
        complete: {
            type: ['object', 'null'],
            "properties" : TaskStatusSchemaDef
        },
        approved: {
            type: ['object', 'null'],
            "properties" : TaskStatusSchemaDef
        }
    }
}

export const TaskAssignmentsSchemaObjectDef = {
    type: [ 'object', 'null' ],
    "properties": {
        scheduleUserId: {
            type: ['string', 'null']
        },
        testUserId: {
            type: ['string', 'null']
        }
    }
}

export const TaskScheduleSchemaObjectDef = {
    type: 'object',
    "properties": {
        scheduleNotes: {
            type: ['string', 'null']
        },
        scheduledDate: {
            type: 'string'
        },
        scheduleComments: {
            type: ['array', 'null'],
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    text: { type: 'string' },
                    archived: { type: 'boolean' },
                    timestamp: { type: 'string' },
                    userId: { type: 'string' }
                }
            }
        }
    }
}

